/**
 * "Change format…" (ADR 0036): the scene adapted to another canvas size, from scene-schema's adaptCanvas (shared with
 * the API's templates, ADR 0037; the rules are described there). The editor drops assets nothing uses any more, as
 * every canvas change does.
 */
import { adaptCanvas as adapt, type AdaptOptions, type AdaptTarget, type Scene } from '@prism-graphics/scene-schema';
import { pruneAssets } from './commands.ts';

export { contentScaleOf, defaultContent, defaultContentScale, type AdaptOptions, type AdaptTarget, type ContentMode } from '@prism-graphics/scene-schema';

/** The scene adapted to `target` (size and frame rate); lengths scaled and elements re-placed. */
export function adaptCanvas(scene: Scene, target: AdaptTarget, opts: AdaptOptions): Scene {
  return pruneAssets(adapt(scene, target, opts));
}
